export default __webpack_public_path__ + "static/media/i20.a2ce16c6.jpeg";